import { searchTypeSelector } from 'src/store/view/selectors';
import type { SagaReturnType } from 'redux-saga/effects';
import { select, takeLatest } from 'redux-saga/effects';
import { dataLayerPush } from 'src/helpers/gtm';
import { getPackageFullPrice } from 'checkout/store/selectors/order';
import { getPackageId } from 'checkout/store/selectors/package';
import { selectIsSbpIncluded } from 'src/store/payment/selectors';
import { sendPaymentMethodAnalytics } from './actions';

function* pushPaymentMethodAnalytics() {
  const searchType: SagaReturnType<typeof searchTypeSelector> = yield select(
    searchTypeSelector,
  );
  const packageId: SagaReturnType<typeof getPackageId> = yield select(
    getPackageId,
  );
  const packagePrice: SagaReturnType<typeof getPackageFullPrice> = yield select(
    getPackageFullPrice,
  );
  const isSbpIncluded: SagaReturnType<typeof selectIsSbpIncluded> =
    yield select(selectIsSbpIncluded);

  dataLayerPush({
    event: 'payment_block_displayed',
    custom_params: {
      payment_type: isSbpIncluded ? 'SBP_included' : 'SBP_excluded',
      search_type: searchType,
      package_id: packageId,
      package_price: packagePrice,
    },
  });
}

export default function* paymentAnalytics() {
  yield takeLatest(sendPaymentMethodAnalytics, pushPaymentMethodAnalytics);
}
